import App from "./App.vue";
import store from "./store/store";
import { createApp } from "@/create-app";
import { initData } from "@/__dev_utils__/init-data";

if (process.env.NODE_ENV === "development") {
  initData("my_customers.js", "personal.my_customers.json")
    .then(() => createApp(App, store))
    .catch(err => console.log(err));
} else {
  createApp(App, store);
}
